import BaseModel from "./Abstracts/BaseModel";
import Module from "./Module";
import CoursePage from "./CoursePage";

export default class Course extends BaseModel{
    constructor(data) {
        super()
        this.$dirty = false
        this.id = null
        this.status = null
        this.name = ''
        this.description = ''
        this.listingDescription = ''
        this.cID = null
        this.status = ''
        this.categoryID = null
        this.createdAt = null
        this.updatedAt = null
        this.modules = {data: []}
        this.pages = {data: []}
        this.tokens = {
            addModule: ''
        }
        this.urls = {
            viewPage: ''
        }
        this.seoMeta = {
            data: {
                title: '',
                description: '',
            }
        }

        this._skipKeys.push('categoryID')
        this._skipKeys.push('modules')
        this._skipKeys.push('pages')
        this._skipKeys.push('urls')
        this._skipKeys.push('tokens')
        this._skipKeys.push('createdAt')
        this._skipKeys.push('updatedAt')
        this._skipKeys.push('seoMeta')

        this.setData(data)
        this.setInitialized()

        this._getAdditionalFormData = function() {
            return {
                metaTitle: this.seoMeta.data.title,
                metaDescription: this.seoMeta.data.description,
            }
        }
    }


    setData(data) {
        super.setData(data)

        if (!data) {
            return;
        }
        this.modules.data = data.modules ? data.modules.data.map(courseModule => new Module(courseModule)) : [];
        this.pages.data = data.pages ? data.pages.data.map(page => new CoursePage(page)) : [];
    }
}
